import { useEffect, useMemo } from 'react';

import { useZodForm } from '../../../hooks/useZodForm.ts';
import { selectMarketAdjustments } from '../../../redux/features/selectors/orderSelectors.ts';
import { selectManualAdjustmentsForMarketAdjustmentsModalForm } from '../../../redux/features/selectors/selectManualAdjustmentsForMarketAdjustmentsModalForm.tsx';
import { useAppSelector } from '../../../redux/hooks.ts';
import { schMarketAdjustmentsModalForm } from '../types.ts';
import { stateToForm } from '../utils/stateToForm.ts';

export function useMarketAdjustmentsModalForm() {
  const manualAdjustments = useAppSelector(selectManualAdjustmentsForMarketAdjustmentsModalForm);
  const marketAdjustments = useAppSelector(selectMarketAdjustments);
  const defaultValues = useMemo(
    () =>
      stateToForm({
        manualAdjustments,
        marketAdjustments,
      }),
    [manualAdjustments, marketAdjustments],
  );

  const form = useZodForm({
    schema: schMarketAdjustmentsModalForm,
    defaultValues,
    mode: 'onBlur',
  });

  useEffect(() => {
    if (form.formState.isDirty) return;
    form.reset(defaultValues, {
      keepTouched: true,
      keepDirtyValues: true,
    });
  }, [defaultValues, form, form.formState.isDirty]);

  return form;
}
